// BUBU v7.33: collection catalog root now participates in quick-add handlers.
document.addEventListener('DOMContentLoaded',()=>{const drawer=document.querySelector('[data-bubu-drawer]');const open=()=>{if(!drawer)return;drawer.classList.add('is-open');document.body.classList.add('bubu-menu-open')};const close=()=>{if(!drawer)return;drawer.classList.remove('is-open');document.body.classList.remove('bubu-menu-open')};document.querySelectorAll('[data-bubu-open]').forEach(b=>b.addEventListener('click',open));document.querySelectorAll('[data-bubu-close]').forEach(b=>b.addEventListener('click',close));drawer&&drawer.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});});

// ===== BUBU v7.7 dynamic catalog =====
document.addEventListener('DOMContentLoaded', () => {
  const catalog = document.querySelector('[data-bubu-catalog]');
  if (!catalog) return;

  const tabs = [...catalog.querySelectorAll('[data-bubu-tab]')];
  const panels = [...catalog.querySelectorAll('[data-bubu-grid-panel]')];
  const grids = [...catalog.querySelectorAll('[data-bubu-product-grid]')];
  const sortSelect = catalog.querySelector('[data-bubu-sort]');
  const filterToggle = catalog.querySelector('[data-bubu-filter-toggle]');
  const filterPanel = catalog.querySelector('[data-bubu-filter-panel]');
  const filterInputs = [...catalog.querySelectorAll('[data-bubu-allergen-filter]')];
  const filterClear = catalog.querySelector('[data-bubu-filter-clear]');
  const filterCount = catalog.querySelector('[data-bubu-filter-count]');
  const resultCount = catalog.querySelector('[data-bubu-result-count]');

  const activeFilters = () => filterInputs.filter(i => i.checked).map(i => i.value.trim().toLowerCase());

  const visibleCards = () => [...catalog.querySelectorAll('[data-bubu-product-card]')].filter(card => {
    const panel = card.closest('[data-bubu-grid-panel]');
    return !panel || !panel.classList.contains('is-hidden');
  });

  const applyFilters = () => {
    const excluded = activeFilters();
    [...catalog.querySelectorAll('[data-bubu-product-card]')].forEach(card => {
      const allergens = (card.dataset.allergens || '').split('|').map(x => x.trim().toLowerCase()).filter(Boolean);
      const shouldHide = excluded.some(a => allergens.includes(a));
      card.hidden = shouldHide;
    });

    grids.forEach(grid => {
      const wrap = grid.parentElement;
      const empty = wrap && wrap.querySelector('[data-bubu-empty-filter]');
      const anyVisible = [...grid.querySelectorAll('[data-bubu-product-card]')].some(card => !card.hidden);
      if (empty) empty.hidden = anyVisible;
    });

    const n = excluded.length;
    if (filterCount) {
      filterCount.hidden = n === 0;
      filterCount.textContent = String(n);
    }
    if (resultCount) {
      const nVisible = visibleCards().filter(c => !c.hidden).length;
      resultCount.textContent = `${nVisible} ${nVisible === 1 ? 'продукт' : (nVisible >= 2 && nVisible <= 4 ? 'продукта' : 'продуктов')}`;
    }
  };

  const sortGrid = (grid, mode) => {
    const cards = [...grid.querySelectorAll('[data-bubu-product-card]')];
    cards.sort((a, b) => {
      if (mode === 'new') return Number(b.dataset.created || 0) - Number(a.dataset.created || 0);
      if (mode === 'price-asc') return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
      if (mode === 'price-desc') return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
      return Number(a.dataset.original || 0) - Number(b.dataset.original || 0);
    });
    cards.forEach(card => grid.appendChild(card));
  };

  const applySort = () => {
    const mode = sortSelect ? sortSelect.value : 'popular';
    grids.forEach(grid => sortGrid(grid, mode));
  };

  tabs.forEach(tab => tab.addEventListener('click', () => {
    const key = tab.dataset.bubuTab;
    tabs.forEach(t => {
      const active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    panels.forEach(panel => panel.classList.toggle('is-hidden', panel.dataset.bubuGridPanel !== key));
    applyFilters();
  }));

  if (sortSelect) sortSelect.addEventListener('change', applySort);

  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const opening = filterPanel.hidden;
      filterPanel.hidden = !opening;
      filterToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });
    filterPanel.addEventListener('click', e => e.stopPropagation());
    document.addEventListener('click', () => {
      filterPanel.hidden = true;
      filterToggle.setAttribute('aria-expanded', 'false');
    });
  }

  filterInputs.forEach(input => input.addEventListener('change', applyFilters));
  if (filterClear) filterClear.addEventListener('click', () => {
    filterInputs.forEach(input => input.checked = false);
    applyFilters();
  });

  const cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let catalogCart = null;

  const cartQtyForVariant = (cart, variantId) => {
    if (!cart || !variantId) return 0;
    return (cart.items || []).filter(item => String(item.variant_id) === String(variantId)).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  };

  const updateCartBadges = (cart) => {
    if (!cart) return;
    document.querySelectorAll('.bubu-cart-count').forEach(el => el.textContent = cart.item_count);
  };

  const announceCatalogCart = (cart) => {
    catalogCart = cart;
    window.BUBUCatalogCart = cart;
    updateCartBadges(cart);
    catalog.querySelectorAll('[data-bubu-quick-add]').forEach(form => {
      if (typeof form._bubuRenderCartQty === 'function') form._bubuRenderCartQty(cart);
    });
  };

  const fetchCatalogCart = async () => {
    try {
      const response = await fetch(cartRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) return null;
      const cart = await response.json();
      announceCatalogCart(cart);
      return cart;
    } catch (e) { console.error('BUBU cart read:', e); return null; }
  };

  catalog.querySelectorAll('[data-bubu-quick-add]').forEach(form => {
    const button = form.querySelector('[data-bubu-add-button]');
    if (!button) return;

    const radios = () => [...form.querySelectorAll('[data-bubu-variant-radio]')];
    const chosen = () => radios().find(radio => radio.checked);
    const popover = form.querySelector('[data-bubu-variant-popover]');
    const hint = form.querySelector('[data-bubu-variant-hint]');
    const qtyInput = form.querySelector('[data-bubu-qty-input]');
    const qtyMinus = form.querySelector('[data-bubu-qty-minus]');
    const qtyPlus = form.querySelector('[data-bubu-qty-plus]');
    const inCartNote = form.querySelector('[data-bubu-in-cart-note]');
    const hiddenId = form.querySelector('input[name="id"]:not([data-bubu-variant-radio])');

    const currentVariantId = () => {
      const radio = chosen();
      if (radio) return radio.value;
      return hiddenId ? hiddenId.value : '';
    };

    const renderCartQty = (cart, preserveStaged = false) => {
      if (!qtyInput) return;
      const variantId = currentVariantId();
      if (!variantId) {
        qtyInput.value = '0';
        form.dataset.cartQty = '0';
        if (inCartNote) inCartNote.hidden = true;
        return;
      }
      const qty = cartQtyForVariant(cart, variantId);
      const staged = Number(qtyInput.value || 0);
      form.dataset.cartQty = String(qty);
      if (!preserveStaged || qty > 0 || staged === 0) qtyInput.value = String(qty);
      if (inCartNote) {
        inCartNote.hidden = qty <= 0;
        inCartNote.textContent = qty > 0 ? `In cart: ${qty}` : 'In cart';
      }
    };
    form._bubuRenderCartQty = renderCartQty;

    const askForVariant = () => {
      if (popover) {
        popover.setAttribute('open', '');
        popover.classList.remove('needs-attention');
        void popover.offsetWidth;
        popover.classList.add('needs-attention');
        const summary = popover.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-invalid', 'true');
          try { summary.focus({preventScroll:true}); } catch(e) { summary.focus(); }
        }
        setTimeout(() => popover.classList.remove('needs-attention'), 950);
      }
      if (hint) {
        hint.hidden = false;
        hint.textContent = 'Please choose a flavor';
        hint.classList.remove('is-visible');
        void hint.offsetWidth;
        hint.classList.add('is-visible');
      }
    };

    const syncExistingCartQty = async (nextQty) => {
      const variantId = currentVariantId();
      if (!variantId) { askForVariant(); return; }
      nextQty = Math.max(0, Math.min(99, Number(nextQty || 0)));
      if (qtyInput) qtyInput.value = String(nextQty);
      try {
        const updates = {}; updates[String(variantId)] = nextQty;
        const response = await fetch(cartRoot + 'cart/update.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!response.ok) throw new Error('Cart update failed');
        const cart = await response.json();
        announceCatalogCart(cart);
      } catch (err) { console.error('BUBU quantity update:', err); }
    };

    const stepQuantity = (delta) => {
      if (button.dataset.requiresVariant === 'true' && !chosen()) { askForVariant(); return; }
      if (!qtyInput) return;
      const current = Math.max(0, Number(qtyInput.value || 0));
      const next = Math.max(0, Math.min(99, current + delta));
      qtyInput.value = String(next);
      const cartQty = Number(form.dataset.cartQty || 0);
      if (cartQty > 0) syncExistingCartQty(next);
    };

    if (qtyMinus) qtyMinus.addEventListener('click', () => stepQuantity(-1));
    if (qtyPlus) qtyPlus.addEventListener('click', () => stepQuantity(1));
    if (qtyInput) qtyInput.addEventListener('change', () => {
      if (button.dataset.requiresVariant === 'true' && !chosen()) { qtyInput.value = '0'; askForVariant(); return; }
      let next = Math.max(0, Math.min(99, Number(qtyInput.value || 0)));
      qtyInput.value = String(next);
      if (Number(form.dataset.cartQty || 0) > 0) syncExistingCartQty(next);
    });

    button.addEventListener('click', (event) => {
      if (button.dataset.requiresVariant === 'true' && !chosen()) {
        event.preventDefault();
        event.stopPropagation();
        askForVariant();
        return;
      }
      event.preventDefault();
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', {bubbles:true,cancelable:true}));
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (button.disabled) return;
      if (button.dataset.requiresVariant === 'true' && !chosen()) { askForVariant(); return; }

      const variantId = currentVariantId();
      if (!variantId) { askForVariant(); return; }
      let desiredQty = qtyInput ? Math.max(0, Math.min(99, Number(qtyInput.value || 0))) : 1;
      if (desiredQty < 1) desiredQty = 1;
      if (qtyInput) qtyInput.value = String(desiredQty);

      button.disabled = true;
      try {
        const currentCartQty = cartQtyForVariant(catalogCart, variantId);
        let cart;
        if (currentCartQty > 0) {
          const updates = {}; updates[String(variantId)] = desiredQty;
          const response = await fetch(cartRoot + 'cart/update.js', {
            method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ updates })
          });
          if (!response.ok) throw new Error('Cart update failed');
          cart = await response.json();
        } else {
          const data = new FormData(form);
          data.set('quantity', String(desiredQty));
          const response = await fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data });
          if (!response.ok) throw new Error('Cart add failed');
          const cartResponse = await fetch(cartRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
          if (!cartResponse.ok) throw new Error('Cart refresh failed');
          cart = await cartResponse.json();
        }

        announceCatalogCart(cart);
        button.classList.add('is-added');
        setTimeout(() => button.classList.remove('is-added'), 1500);
      } catch (err) {
        console.error('BUBU quick add:', err);
      } finally {
        setTimeout(() => { button.disabled = false; }, 1550);
      }
    });
  });

  fetchCatalogCart();

  applySort();
  applyFilters();
});


document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-bubu-faq]').forEach(faq=>{const btn=faq.querySelector('[data-bubu-faq-more]');if(!btn)return;const extra=[...faq.querySelectorAll('.bubu-faq-extra')],label=btn.querySelector('[data-bubu-faq-more-label]'),more=label?label.textContent:'Показать все вопросы',less=faq.dataset.lessLabel||'Свернуть вопросы';btn.addEventListener('click',()=>{const expanded=btn.getAttribute('aria-expanded')==='true';extra.forEach(x=>{x.hidden=!expanded?false:true;if(expanded)x.removeAttribute('open')});btn.setAttribute('aria-expanded',expanded?'false':'true');if(label)label.textContent=expanded?more:less})})});

// BUBU v7.15: variant pills update the visible price on catalog cards.
document.addEventListener('change', function(event){
  const radio = event.target.closest('[data-bubu-variant-radio]');
  if (!radio) return;
  const form = radio.closest('[data-bubu-quick-add]');
  if (!form) return;
  const price = form.querySelector('[data-bubu-card-price]');
  if (!price) return;
  const cents = Number(radio.dataset.variantPrice || 0);
  try {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GEL';
    price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  } catch (e) {
    price.textContent = (cents / 100).toFixed(2) + ' GEL';
  }
});

// BUBU v7.15: client-side sorting keeps each visual category together.
document.addEventListener('DOMContentLoaded', function(){
  const select = document.querySelector('[data-bubu-group-sort]');
  if (!select) return;
  const sortGrid = (grid, mode) => {
    const cards = Array.from(grid.querySelectorAll('[data-bubu-product-card]'));
    cards.sort((a,b) => {
      if (mode === 'new') return Number(b.dataset.created || 0) - Number(a.dataset.created || 0);
      if (mode === 'price-asc') return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
      if (mode === 'price-desc') return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
      if (mode === 'title') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
      return Number(a.dataset.original || 0) - Number(b.dataset.original || 0);
    });
    cards.forEach(card => grid.appendChild(card));
  };
  select.addEventListener('change', function(){
    document.querySelectorAll('.bubu-continuous-catalog [data-bubu-product-grid], .bubu-all-collection:not(.bubu-all-collection--grouped) [data-bubu-product-grid]').forEach(grid => sortGrid(grid, this.value));
  });
});


// BUBU v7.16.1 — All products / Boxes use the guaranteed /collections/all route.
document.addEventListener('DOMContentLoaded', () => {
  const routeViews = document.querySelectorAll('[data-bubu-route-view]');
  if (!routeViews.length) return;
  const requested = new URLSearchParams(window.location.search).get('bubu_view') === 'boxes' ? 'boxes' : 'products';
  routeViews.forEach(el => { el.hidden = el.dataset.bubuRouteView !== requested; });

  // v7.46 — after switching the shared catalog into Boxes view, honor deep links such as For moms.
  if (window.location.hash) {
    window.requestAnimationFrame(() => {
      const target = document.querySelector(window.location.hash);
      if (target && !target.closest('[hidden]')) target.scrollIntoView({ block: 'start' });
    });
  }

  document.querySelectorAll('[data-bubu-group-sort]').forEach(select => {
    select.addEventListener('change', () => {
      document.querySelectorAll('[data-bubu-route-view="products"] [data-bubu-product-grid]').forEach(grid => {
        const cards=[...grid.querySelectorAll('[data-bubu-product-card]')];
        const mode=select.value;
        cards.sort((a,b)=>{
          if(mode==='new') return Number(b.dataset.created||0)-Number(a.dataset.created||0);
          if(mode==='price-asc') return Number(a.dataset.price||0)-Number(b.dataset.price||0);
          if(mode==='price-desc') return Number(b.dataset.price||0)-Number(a.dataset.price||0);
          if(mode==='title') return (a.dataset.title||'').localeCompare(b.dataset.title||'');
          return Number(a.dataset.original||0)-Number(b.dataset.original||0);
        });
        cards.forEach(card=>grid.appendChild(card));
      });
    });
  });
});


// BUBU v7.16.3 — branded For kids / For moms tab state.
document.addEventListener('DOMContentLoaded', function(){
  const nav=document.querySelector('[data-bubu-box-tabs]');
  if(!nav) return;
  const tabs=[...nav.querySelectorAll('[data-bubu-box-tab]')];
  const setActive=(key)=>tabs.forEach(tab=>tab.classList.toggle('is-active',tab.dataset.bubuBoxTab===key));
  if (window.location.hash === '#bubu-boxes-moms') setActive('moms');
  tabs.forEach(tab=>tab.addEventListener('click',()=>setActive(tab.dataset.bubuBoxTab)));
  const kids=document.getElementById('bubu-boxes-kids');
  const moms=document.getElementById('bubu-boxes-moms');
  if('IntersectionObserver' in window && kids && moms){
    const observer=new IntersectionObserver(entries=>{
      const visible=entries.filter(e=>e.isIntersecting).sort((a,b)=>b.intersectionRatio-a.intersectionRatio)[0];
      if(!visible) return;
      setActive(visible.target.id==='bubu-boxes-moms'?'moms':'kids');
    },{rootMargin:'-25% 0px -55% 0px',threshold:[0,.15,.35,.6]});
    observer.observe(kids); observer.observe(moms);
  }
});

// BUBU catalog v7.27 — compact flavor chooser.
document.addEventListener('change', function(event){
  const radio = event.target.closest('[data-bubu-variant-radio]');
  if (!radio) return;
  const form = radio.closest('[data-bubu-quick-add]');
  if (!form) return;
  const label = form.querySelector('[data-bubu-choice-label]');
  if (label) label.textContent = radio.dataset.variantLabel || 'Selected';
  const popover = form.querySelector('[data-bubu-variant-popover]');
  if (popover) {
    popover.classList.remove('needs-attention');
    const summary = popover.querySelector('summary');
    if (summary) summary.removeAttribute('aria-invalid');
    popover.removeAttribute('open');
  }
  const hint = form.querySelector('[data-bubu-variant-hint]');
  if (hint) hint.hidden = true;
  if (typeof form._bubuRenderCartQty === 'function') form._bubuRenderCartQty(window.BUBUCatalogCart || null);
});



// BUBU v7.50 — mobile catalog back button.
document.addEventListener('click', function(event){
  const back = event.target.closest('[data-bubu-history-back]');
  if (!back) return;
  event.preventDefault();
  if (window.history.length > 1) window.history.back();
  else window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
});


// BUBU v7.51 — compact mobile reviews carousel with arrows + native swipe.
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-bubu-reviews]').forEach(section => {
    const track = section.querySelector('[data-bubu-review-track]');
    const prev = section.querySelector('[data-bubu-review-prev]');
    const next = section.querySelector('[data-bubu-review-next]');
    if (!track || !prev || !next) return;
    const move = (direction) => {
      const card = track.querySelector('.bubu-review');
      const gap = parseFloat(getComputedStyle(track).gap || 0) || 12;
      const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });
});
